import * as G from 'ApplicationEntry/models/ProductsRiders/IWL/GroupIWL';
import {IWL, matchIWLByType} from 'ApplicationEntry/models/ProductsRiders/IWL/IWL';
import * as NY from 'ApplicationEntry/models/ProductsRiders/IWL/NewYorkIWL';
import * as O from 'ApplicationEntry/models/ProductsRiders/IWL/OrdinaryIWL';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {
  SalaryDeductionOccupationClassInfo,
  SalaryDeductionOccupationClassModel,
} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';
import {Async, Loaded, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum IWLActionType {
  CHANGE_PLAN = 'iwl/CHANGE_PLAN',
  CHANGE_COVERAGE_LEVEL = 'iwl/CHANGE_COVERAGE_LEVEL',
  CHANGE_PREMIUM = 'iwl/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'iwl/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'iwl/CHANGE_CWA',
  CHANGE_SITUS_STATE = 'iwl/CHANGE_SITUS_STATE',
  CHANGE_TYPE = 'iwl/CHANGE_TYPE',
  CHANGE_FACE_AMT = 'iwl/CHANGE_FACE_AMT',
  CHANGE_POLICY_NUM = 'iwl/CHANGE_POLICY_NUM',
  CHANGE_PREMIUM_TYPE = 'iwl/CHANGE_PREMIUM_TYPE',
  CHANGE_PRI_INSURED = 'iwl/CHANGE_PRI_INSURED',
  CHANGE_SPOUSE_INSURED = 'iwl/CHANGE_SPOUSE_INSURED',
  CHANGE_AUTO_ISSUE_ELIGIBILTY = 'iwl/CHANGE_AUTO_ISSUE_ELIGIBILTY',
  CHANGE_REPLACEMENT = 'iwl/CHANGE_REPLACEMENT',
  CHANGE_RIDER_CODES = 'iwl/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMTS = 'iwl/CHANGE_RIDER_AMTS',
  CHANGE_RIDER_INFORMATION = 'iwl/CHANGE_RIDER_INFORMATION',
  CHANGE_OCC_CLASS = 'iwl/CHANGE_OCC_CLASS',
  GET_OCC_CLASS = 'iwl/GET_OCC_CLASS',
  REMOVE_RIDER = 'iwl/REMOVE_RIDER',
  GET_PACKAGE_LIST = 'iwl/GET_PACKAGE_LIST',
  CHANGE_PACKAGE_LIST = 'iwl/CHANGE_PACKAGE_LIST',
  CHANGE_PACKAGE_NAME = 'iwl/CHANGE_PACKAGE_NAME',
  CHANGE_PACKAGE_ITEM = 'iwl/CHANGE_PACKAGE_ITEM',
  CHANGE_WAIVER = 'iwl/CHANGE_WAIVER',
  CHANGE_ADB_TERMINAL = 'iwl/CHANGE_ADB_TERMINAL',
}

export const isIWLAction = (action: any): action is IWLAction => action.type in reverseEnum(IWLActionType);

export const changeCoverageLevel = (coverageLevel: string) =>
  createAction(IWLActionType.CHANGE_COVERAGE_LEVEL, {coverageLevel});
export const changePlan = (plan: string) => createAction(IWLActionType.CHANGE_PLAN, {plan});
export const changePremium = (premium: string) => createAction(IWLActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(IWLActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(IWLActionType.CHANGE_CWA, {cwa});
export const changeSitusState = (state: string) => createAction(IWLActionType.CHANGE_SITUS_STATE, {state});
export const changeType = (type: string) => createAction(IWLActionType.CHANGE_TYPE, {type});
export const changeFaceAmt = (amt: string) => createAction(IWLActionType.CHANGE_FACE_AMT, {amt});
export const changePolicyNum = (polNumber: string) => createAction(IWLActionType.CHANGE_POLICY_NUM, {polNumber});
export const changePriInsured = (insured: string) => createAction(IWLActionType.CHANGE_PRI_INSURED, {insured});
export const changeSpouseInsured = (insured: string) => createAction(IWLActionType.CHANGE_SPOUSE_INSURED, {insured});
export const changePremiumType = (type: string) => createAction(IWLActionType.CHANGE_PREMIUM_TYPE, {type});
export const changeEligibility = (eligibility: boolean) =>
  createAction(IWLActionType.CHANGE_AUTO_ISSUE_ELIGIBILTY, {eligibility});
export const changeReplacement = (replacement: boolean) =>
  createAction(IWLActionType.CHANGE_REPLACEMENT, {replacement});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(IWLActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changeRiderAmts = (riderAmt: number, index: number) =>
  createAction(IWLActionType.CHANGE_RIDER_AMTS, {riderAmt, index});
export const changeRiderInformation = (amount: number, code: string, index: number) =>
  createAction(IWLActionType.CHANGE_RIDER_INFORMATION, {amount, code, index});
export const removeRider = (index: number) => createAction(IWLActionType.REMOVE_RIDER, {index});
export const changeOccClass = (occClass: SalaryDeductionOccupationClassModel) =>
  createAction(IWLActionType.CHANGE_OCC_CLASS, {occClass});
export const getOccClass = (caseNumber: string, plan: Plan) =>
  createAction(IWLActionType.GET_OCC_CLASS, {caseNumber, plan});
export const getPackageList = (caseNumber: string, planCode: string) =>
  createAction(IWLActionType.GET_PACKAGE_LIST, {caseNumber, planCode});
export const changePackageList = (packages: Async<object[]>) =>
  createAction(IWLActionType.CHANGE_PACKAGE_LIST, {packages});

export const changePackageName = (packageName: string) =>
  createAction(IWLActionType.CHANGE_PACKAGE_NAME, {packageName});
export const changePackageItem = (packageItem: object) =>
  createAction(IWLActionType.CHANGE_PACKAGE_ITEM, {packageItem});
export const changeWaiver = (waiver: boolean) => createAction(IWLActionType.CHANGE_WAIVER, {waiver});
export const changeAdbTerminal = (adbTerminal: boolean) =>
  createAction(IWLActionType.CHANGE_ADB_TERMINAL, {adbTerminal});

export type IWLAction =
  | ReturnType<typeof changePlan>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeType>
  | ReturnType<typeof changeFaceAmt>
  | ReturnType<typeof changePolicyNum>
  | ReturnType<typeof changePriInsured>
  | ReturnType<typeof changeSpouseInsured>
  | ReturnType<typeof changePremiumType>
  | ReturnType<typeof changeEligibility>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmts>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof changeOccClass>
  | ReturnType<typeof getOccClass>
  | ReturnType<typeof changeCoverageLevel>
  | ReturnType<typeof removeRider>
  | ReturnType<typeof getPackageList>
  | ReturnType<typeof changePackageList>
  | ReturnType<typeof changePackageName>
  | ReturnType<typeof changePackageItem>
  | ReturnType<typeof changeWaiver>
  | ReturnType<typeof changeAdbTerminal>;

type IWLState = IWL;

export default (state: IWLState, action: IWLAction): IWLState => {
  switch (action.type) {
    case IWLActionType.CHANGE_PLAN:
      return matchIWLByType<IWL>({
        Ordinary: O.changePlan(action.payload.plan),
        Group: G.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case IWLActionType.CHANGE_COVERAGE_LEVEL:
      return matchIWLByType<IWL>({
        _: () => state,
        Group: G.changeCoverageLevel(action.payload.coverageLevel),
      })(state);
    case IWLActionType.CHANGE_PREMIUM:
      return matchIWLByType<IWL>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case IWLActionType.CHANGE_CALCULATED_PREMIUM:
      return matchIWLByType<IWL>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case IWLActionType.CHANGE_CWA:
      return matchIWLByType<IWL>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case IWLActionType.CHANGE_SITUS_STATE:
      return matchIWLByType<IWL>({
        Ordinary: O.changeSitusState(action.payload.state),
        Group: G.changeSitusState(action.payload.state),
        NewYork: NY.changeSitusState(action.payload.state),
      })(state);
    case IWLActionType.CHANGE_TYPE:
      return matchIWLByType<IWL>({
        Ordinary: O.changeType(action.payload.type),
        Group: G.changeType(action.payload.type),
        NewYork: NY.changeType(action.payload.type),
      })(state);
    case IWLActionType.CHANGE_FACE_AMT:
      return matchIWLByType<IWL>({
        Ordinary: O.changeFaceAmt(action.payload.amt),
        Group: G.changeFaceAmt(action.payload.amt),
        NewYork: NY.changeFaceAmt(action.payload.amt),
      })(state);
    case IWLActionType.CHANGE_POLICY_NUM:
      return matchIWLByType<IWL>({
        Ordinary: O.changePolicyNumber(action.payload.polNumber),
        Group: G.changePolicyNumber(action.payload.polNumber),
        NewYork: NY.changePolicyNumber(action.payload.polNumber),
      })(state);
    case IWLActionType.CHANGE_PREMIUM_TYPE:
      return matchIWLByType<IWL>({
        Ordinary: O.changePremiumType(action.payload.type),
        Group: G.changePremiumType(action.payload.type),
        NewYork: NY.changePremiumType(action.payload.type),
      })(state);
    case IWLActionType.CHANGE_PRI_INSURED:
      return matchIWLByType<IWL>({
        Ordinary: O.changePriInsured(action.payload.insured),
        Group: G.changePriInsured(action.payload.insured),
        NewYork: NY.changePriInsured(action.payload.insured),
      })(state);
    case IWLActionType.CHANGE_SPOUSE_INSURED:
      return matchIWLByType<IWL>({
        Ordinary: O.changeSpouseInsured(action.payload.insured),
        Group: G.changeSpouseInsured(action.payload.insured),
        NewYork: NY.changeSpouseInsured(action.payload.insured),
      })(state);
    case IWLActionType.CHANGE_AUTO_ISSUE_ELIGIBILTY:
      return matchIWLByType<IWL>({
        Ordinary: O.changeAutoIssue(action.payload.eligibility),
        Group: G.changeAutoIssue(action.payload.eligibility),
        NewYork: NY.changeAutoIssue(action.payload.eligibility),
      })(state);
    case IWLActionType.CHANGE_REPLACEMENT:
      return matchIWLByType<IWL>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: NY.changeReplacement(action.payload.replacement),
      })(state);
    case IWLActionType.CHANGE_RIDER_CODES:
      return matchIWLByType<IWL>({
        NewYork: NY.changeRiderCodes(action.payload.riderCode, action.payload.index),
        _: () => state,
      })(state);
    case IWLActionType.CHANGE_RIDER_AMTS:
      return matchIWLByType<IWL>({
        NewYork: NY.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        _: () => state,
      })(state);
    case IWLActionType.CHANGE_RIDER_INFORMATION:
      return matchIWLByType<IWL>({
        Ordinary: O.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        Group: G.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        _: () => state,
      })(state);
    case IWLActionType.REMOVE_RIDER:
      return matchIWLByType<IWL>({
        Ordinary: O.removeRider(action.payload.index),
        _: () => state,
      })(state);
    case IWLActionType.CHANGE_OCC_CLASS:
      return matchIWLByType<IWL>({
        Ordinary: O.changeOccClass(action.payload.occClass),
        Group: G.changeOccClass(action.payload.occClass),
        _: () => state,
      })(state);
    case IWLActionType.GET_OCC_CLASS:
      return matchIWLByType<IWL>({
        Ordinary: O.changeOccClass(new Loading()),
        Group: G.changeOccClass(new Loading()),
        _: () => state,
      })(state);
    case IWLActionType.GET_PACKAGE_LIST:
      return matchIWLByType<IWL>({
        Ordinary: () => state,
        Group: G.changePackageList(new Loading()),
        NewYork: () => state,
      })(state);
    case IWLActionType.CHANGE_PACKAGE_LIST:
      return matchIWLByType<IWL>({
        Ordinary: () => state,
        Group: G.changePackageList(action.payload.packages),
        NewYork: () => state,
      })(state);
    case IWLActionType.CHANGE_PACKAGE_NAME:
      return matchIWLByType<IWL>({
        Ordinary: () => state,
        Group: G.changePackageName(action.payload.packageName),
        NewYork: () => state,
      })(state);

    case IWLActionType.CHANGE_PACKAGE_ITEM:
      return matchIWLByType<IWL>({
        Ordinary: () => state,
        Group: G.changePackageItem(action.payload.packageItem),
        NewYork: () => state,
      })(state);
    case IWLActionType.CHANGE_WAIVER:
      return matchIWLByType<IWL>({
        Ordinary: () => state,
        Group: G.changeWaiver(action.payload.waiver),
        NewYork: () => state,
      })(state);
    case IWLActionType.CHANGE_ADB_TERMINAL:
      return matchIWLByType<IWL>({
        Ordinary: () => state,
        Group: G.changeAdbTerminal(action.payload.adbTerminal),
        NewYork: () => state,
      })(state);
    default:
      return state;
  }
};
